import { Injectable } from "@angular/core";
import { IID_OL_APPARATO } from "@common/interfaces/interfaceData";
import { AbstractInterfaceDataQuery } from "../interfaceDataModel";
import { IIDolApparatoStore } from "./iidOlApparato.store";
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.APPARATO)
export class IIDolApparatoQuery extends AbstractInterfaceDataQuery<IID_OL_APPARATO> {

  constructor(protected store: IIDolApparatoStore) {
    super(store);
  }
}
